import type { ProductSearchResult } from './use-product-type-ahead-search';

type ParentProduct = {
  name?: string;
  sku?: string;
};

const DISABLED_REASON_SELF = 'DISABLED_REASON_SELF';
const DISABLED_REASON_BUNDLE = 'DISABLED_REASON_BUNDLE';

type ProductDisabledState = {
  isDisabled: boolean;
  disabledReason?: typeof DISABLED_REASON_SELF | typeof DISABLED_REASON_BUNDLE;
};

export const checkProductDisabled = (
  product: ProductSearchResult,
  excludeBundles?: boolean,
  parentProduct?: ParentProduct,
): ProductDisabledState => {
  const hasValidParentName = parentProduct?.name && parentProduct.name.trim().length > 0;
  const hasValidParentSku = parentProduct?.sku && parentProduct.sku.trim().length > 0;

  if (
    hasValidParentName &&
    hasValidParentSku &&
    product.name === parentProduct.name &&
    product.sku.toLowerCase() === parentProduct.sku?.toLowerCase()
  ) {
    return { isDisabled: true, disabledReason: DISABLED_REASON_SELF };
  }

  if (excludeBundles && product.isBundle) {
    return { isDisabled: true, disabledReason: DISABLED_REASON_BUNDLE };
  }

  return { isDisabled: false };
};
